export class AgentInformation {
    producerCode: string;
    LegacyChubbCode: string;
    agencyName: string;
    producerName: string;
    producerEmail: string;
}
